import { render, staticRenderFns } from "./TestingChangeSettings.vue?vue&type=template&id=5347a720"
import script from "./TestingChangeSettings.vue?vue&type=script&lang=ts"
export * from "./TestingChangeSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports